import React, { PureComponent } from 'react';

export class SwitchInput extends PureComponent {
  render() {
    let { value, onChange, triState, label, className, id, ...other } = this.props;

    className = className || '';
    if (value === false) {
      className += ' custom-switch--false';
    }

    let onClick = (e) => {
      e.stopPropagation();
      onChange(!value);
    }
    if (triState) {
      onClick = (e) => {
        e.stopPropagation();
        onChange(value ? !value : (value === false ? undefined : true));
      }
    }

    return <span onClick={onClick} className={`custom-control no-select custom-switch ${triState ? 'custom-switch--tri-state' : ''} ${className || ''}`} {...other}>
      <input type="checkbox" className={'custom-control-input '} checked={value || false} id={id} onChange={onChange}/>
      <label className="custom-control-label" htmlFor={id}>{this.props.children || label}</label>
    </span>
  }
}
